import { Skill, SkillType } from '@borg/types';

class SkillSearchRepository extends Repository<Skill> {
  getMany(query: string, type: SkillType) {
    return this._getMany({ url: `/skills?type=${type}&search=${query}` });
  }
}

export const skillSearchRepository = new SkillSearchRepository();
